<template>
    <div>
        <div class="main">
            <div :class="liveStreamingInfo.status === 1 ? 'head' : 'head headEnd'">
                <div class="head_name">
                    <van-image class="head_portrait"
                        :src="!hasPassword ? liveStreamingInfo.anchorInfo.avatar : getImgUrl('publicMobile/live-pull-stream/yeahgo.png')" />
                    <span>{{ !hasPassword ? liveStreamingInfo.anchorInfo.nick : '约购APP' }}</span>
                </div>
                <div class="open_yeahgo" @click="openYeahgo">
                    打开约购
                </div>
            </div>
            <!-- <video v-if="isAndroid" controls id="videoPlayer" ref="videoPlayer" autoplay playsinline="true"
                webkit-playsinline="true" x-webkit-airplay="allow"></video> -->
            <div class="video_wrap">
                <!-- <div id="videoPlayer" ref="videoPlayer"></div> -->
                <div class="liveStreamingEnd" v-if="liveStreamingInfo.status === 1">
                    <div class="tis">
                        直播进行中
                    </div>
                    <div class="user">
                        <van-image class="head_portrait" :src="liveStreamingInfo.anchorInfo.avatar" />
                        <p>{{ liveStreamingInfo.anchorInfo.nick }}</p>
                    </div>
                    <div class="open_yeahgo" @click="openYeahgo">打开约购，和主播打个招呼</div>
                </div>
            </div>
            <div class="encryption" v-if="liveStreamingInfo.status === 1 && hasPassword">
                <van-image class="encryption_logo" :src="getImgUrl('publicMobile/live-pull-stream/LOGO.png')" />
                <div class="direct_broadcasting_room" @click="enterPassword">
                    <div>
                        <span class="signal"></span>
                        <span class="signal"></span>
                        <span class="signal2"></span>
                    </div>
                    点击进入直播间
                </div>
                <van-dialog :overlay="false" v-model="show" title="直播间密码" show-cancel-button
                    :before-close="checkPassword" @close="value = ''; showKeyboard = false">
                    <van-password-input :value="value" :focused="showKeyboard" @focus="showKeyboard = true" length="4"
                        :mask="false" style="margin: 20px 0;" :error-info="errorInfo" />
                </van-dialog>
            </div>
            <div class="liveStreamingEnd" v-if="liveStreamingInfo.status === 2">
                <div class="tis">
                    直播已结束
                </div>
                <div class="user">
                    <van-image class="head_portrait" :src="liveStreamingInfo.anchorInfo.avatar" />
                    <p>{{ liveStreamingInfo.anchorInfo.nick }}</p>
                </div>
                <div class="open_yeahgo" @click="openYeahgo">打开约购，和主播打个招呼</div>
            </div>
            <!-- <div class="footer" v-if="!hasPassword">
                <div class="function" @click="openYeahgo">
                    <div class="comment">
                        说点什么...
                        <van-image class="expression"
                            :src="getImgUrl('publicMobile/live-pull-stream/expression.png')" />
                    </div>
                    <van-image class="share" :src="getImgUrl('publicMobile/live-pull-stream/more.png')" />
                    <van-image class="share" :src="getImgUrl('publicMobile/live-pull-stream/gift.png')" />
                    <van-image class="share" :src="getImgUrl('publicMobile/live-pull-stream/like.png')" />
                </div>
                <div class="open_yeahgo" @click="openYeahgo">打开约购，和主播打个招呼</div>
            </div> -->
            <van-number-keyboard :show="showKeyboard" @input="onInput" @delete="onDelete" />

        </div>
        <div class="wx_main" v-if="wxShow">
            <van-image class="guidance" :src="getImgUrl('publicMobile/live-pull-stream/background.png')" />
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Image as VanImage, PasswordInput, Dialog, NumberKeyboard } from 'vant';
import { getImgUrl } from '@/utils/tools';
import teamApi from '@/apis/live-pull-stream';
// import Hls from 'hls.js';
import CallApp from 'callapp-lib';
import { DOWNLOAD_ANDROID, DOWNLOAD_IOS } from '@/constant/common';
// import Player from 'xgplayer';
// import 'xgplayer/dist/index.min.css';
// import HlsPlugin from 'xgplayer-hls'

Vue.use(VanImage);
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
Vue.use(Dialog);


export default {
    props: {

    },
    data() {
        return {
            show: false,
            value: '',
            showKeyboard: false,
            isInWechat: false,
            hls: null,
            liveStreamingInfo: {},
            hasPassword: false,
            errorInfo: '',
            liveId: '',
            wxShow: false,
            isAndroid: window.navigator.userAgent.toLowerCase().indexOf('Android') > -1 || window.navigator.userAgent.toLowerCase().indexOf('Adr') > -1
        }
    },
    components: {

    },
    created() {
        const ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_') {
            this.isInWechat = true;
        }
        const { query } = this.$route;
        this.liveId = query.liveId

    },
    mounted() {
        this.init()
    },
    beforeDestroy() {
        if (this.hls) {
            this.hls.destroy();
        }
    },
    methods: {
        getImgUrl,
        init() {
            const params = {
                liveId: this.liveId,
                live: 1,
            }
            teamApi.getLiveInfo(params).then(res => {
                if (res.code == 0) {
                    // this.hasPassword = res.data.hasPassword
                    this.liveStreamingInfo = res.data
                    if (!this.hasPassword && res.data.status === 1) {
                        let url = res.data.hlsPlayUrl.replace(/^https?/, 'https')
                        this.createPlayer(url); // 例如: 'http://pili-live-hls.yeahgo.com/yeahgo/1721438431472848897.m3u8'
                    }
                    document.title = res.data.title
                }
            })
        },
        openYeahgo() { //打开约购
            if (this.isInWechat) {
                // this.$router.push({
                //   path: '/web/guidance-app',
                //   query: {},
                // });
                this.wxShow = true
                return;
            }
            // if (this.$store.state.appInfo.isApp || this.$store.state.appInfo.isMiniprogram) {
            //     return;
            // }
            console.log('DOWNLOAD_ANDROID', DOWNLOAD_ANDROID);
            const options = {
                scheme: {
                    //URL Scheme 的 scheme 字段，要打开的 APP 的标识
                    protocol: 'yeahgo'
                },
                //安卓原生谷歌浏览器必须传递 Intent 协议地址，才能唤起 APP
                intent: {
                    // APP包名
                    package: 'com.hznt.yeahgo',
                    scheme: 'yeahgo'
                },
                timeout: '3000',
                //APP 的 App Store
                appstore: DOWNLOAD_IOS,
                //APP 的应用宝地址，
                yingyongbao: DOWNLOAD_ANDROID,
                fallback: DOWNLOAD_ANDROID,
            };
            const callLib = new CallApp(options);
            const appUrl = `https://www.yeahgo.com/hn_live/detail?liveId=${this.liveId}`;
            callLib.open({
                path: "",
                //要传递的参数
                param: {
                    parameter: appUrl,
                }
            })
        },
        createPlayer(source) {
            return;
            // console.log("🚀 ~ createPlayer ~ source:", source)
            // const video = this.$refs.videoPlayer;
            // let player
            // if (document.createElement('video').canPlayType('application/vnd.apple.mpegurl')) {
            //     // 原生支持 hls 播放
            //     player = new Player({
            //         el: video,
            //         url: source,
            //         height: '100%',
            //         width: '100%',
            //         autoplay: true,
            //         controls: false,
            //         'x5-video-player-type': 'h5',
            //     })
            // } else if (HlsPlugin.isSupported()) { // 第一步
            //     player = new Player({
            //         el: video,
            //         height: '100%',
            //         width: '100%',
            //         isLive: false,
            //         autoplay: true,
            //         controls: false,
            //         'x5-video-player-type': 'h5',
            //         url: source, // hls 流地址
            //         plugins: [HlsPlugin] // 第二步
            //     })
            // }

            // player.on('error', (error) => {
            //     console.log("🚀 ~ player.on ~ error:", error)
            //     this.$refs.videoPlayer.style.display = 'none'
            //     this.$set(this.liveStreamingInfo, 'status', 2)
            // })
            // if (this.isAndroid) {
            //     if (Hls.isSupported()) {
            //         console.log(11111111);
            //         this.hls = new Hls();
            //         this.hls.loadSource(source);
            //         this.hls.attachMedia(video);
            //         this.hls.on(Hls.Events.MANIFEST_PARSED, function () {
            //             video.play();
            //         });
            //     }
            //     else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            //         console.log(22222222);
            //         video.src = source;
            //         video.addEventListener('loadedmetadata', function () {
            //             video.play();
            //         });
            //     }
            // } else {

            // }



        },
        enterPassword() {
            this.show = true
            this.showKeyboard = true
        },
        confirmPassword() {
            this.show = false
            this.showKeyboard = false
        },
        onInput(value) {
            this.value += `${value}`
        },
        onDelete() {
            this.value = this.value.slice(0, -1);
            this.errorInfo = ''
        },
        checkPassword(action, done) {
            if (action === 'confirm') {
                if (this.value.length !== 4) {
                    this.errorInfo = '请输入4位密码'
                    done(false)
                    return
                }
                const params = {
                    liveId: this.liveId,
                    live: 1,
                    password: this.value,
                }

                teamApi.checkPassword(params, { showError: false, showLoading: false }).then(res => {
                    if (res.code == 0) {
                        this.hasPassword = false
                        let url = this.liveStreamingInfo.hlsPlayUrl.replace(/^https?/, 'https')
                        if (this.liveStreamingInfo.status === 1) {
                            this.createPlayer(url)
                        }
                        this.confirmPassword()
                        done()
                    } else {
                        this.errorInfo = res.msg
                        done(false)
                    }
                })
            } else {
                done()
            }

        }
    },
}

</script>


<style lang="scss" scoped>
.video_wrap {
    display: flex;
    align-items: center;
    flex: 1;
}

.main {
    height: 100vh;
    background-color: #504d4d;
    margin: 0;
    padding: 0;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;

    .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding: 0 10px 0 19px;
        width: 100%;
        height: 67px;
        z-index: 9999;
        flex-shrink: 0;

        .head_name {
            display: flex;
            align-items: center;
            font-size: 20px;
            font-family: OPPOSans-Medium, OPPOSans;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 17px;
            text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);

            .head_portrait {
                width: 40px;
                height: 40px;
                margin-right: 6px;
                border-radius: 50%;
                overflow: hidden;
            }
        }

        .open_yeahgo {
            text-align: center;
            width: 110px;
            height: 34px;
            background: linear-gradient(95deg, #FF6E53 0%, #FF0000 100%);
            border-radius: 74px 74px 74px 74px;
            opacity: 1;
            font-size: 16px;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 34px;
        }
    }

    .headEnd {
        background: #020200;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
    }

    #videoPlayer {
        width: 100%;
        height: 100vh;
        object-fit: cover;
    }

    // video::-webkit-media-controls-enclosure {
    //  display: none;
    // }
    .encryption {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -30%);

        .encryption_logo {
            width: 166px;
            height: 139px;
        }

        .direct_broadcasting_room {
            width: 174px;
            height: 40px;
            background: rgba(216, 216, 216, 0.02);
            border-radius: 64px 64px 64px 64px;
            opacity: 1;
            border: 2px solid rgba(255, 255, 255, 0.2);
            font-size: 18px;
            font-family: OPPOSans-Bold, OPPOSans;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 35px;
            text-align: center;
            margin-top: 42px;
            display: flex;
            justify-content: center;
            align-items: center;

            .signal {
                width: 2px;
                height: 15px;
                background: #FFFFFF;
                border-radius: 1px 1px 1px 1px;
                opacity: 1;
                display: inline-block;
                margin: 0 2px;
            }

            .signal2 {
                width: 2px;
                height: 10px;
                background: #FFFFFF;
                border-radius: 1px 1px 1px 1px;
                opacity: 1;
                display: inline-block;
                margin: 0 10px 0 2px;
            }
        }
    }

    .liveStreamingEnd {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -30%);
        display: flex;
        flex-direction: column;
        align-items: center;

        .tis {
            font-size: 36px;
            font-family: OPPOSans-Medium, OPPOSans;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 17px;
            text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
        }

        .user {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 90px;

            .head_portrait {
                width: 80px;
                height: 80px;
                border-radius: 40px;
                opacity: 1;
                border-radius: 50%;
                overflow: hidden;
            }

            p {
                font-size: 20px;
                font-family: OPPOSans-Medium, OPPOSans;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 17px;
                text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
                margin-top: 10px;
            }
        }

        .open_yeahgo {
            width: 296px;
            height: 52px;
            background: linear-gradient(95deg, #FF6E53 0%, #FF0000 100%);
            border-radius: 74px 74px 74px 74px;
            opacity: 1;
            font-size: 16px;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 52px;
            text-align: center;
            margin-top: 32px;
        }
    }

    .footer {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        bottom: 0;
        padding: 17px 13px;
        flex-shrink: 0;

        .function {
            display: flex;
            justify-content: space-between;

            .comment {
                display: flex;
                justify-content: space-between;
                padding: 0 3px 0 18px;
                width: 180px;
                height: 39px;
                background: #111118;
                border-radius: 98px 98px 98px 98px;
                opacity: 0.2;
                font-size: 14px;
                font-family: OPPOSans-Medium, OPPOSans;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.66);
                line-height: 39px;
                margin-bottom: 12px;

                .expression {
                    width: 36px;
                    height: 36px;
                }
            }

            .share {
                width: 39px;
                height: 39px;
            }
        }

        .open_yeahgo {
            text-align: center;
            width: 296px;
            height: 44px;
            background: linear-gradient(95deg, #FF6E53 0%, #FF0000 100%);
            border-radius: 74px 74px 74px 74px;
            opacity: 1;
            font-size: 16px;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 44px;
            margin: 0 auto;
        }

    }
}

.wx_main {
    min-height: 100vh;
    background-color: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;

    .guidance {
        width: 100%;
    }
}
</style>